import { ColorScaleConfig } from '@/utils/colorScale'

export const temperatureColorScale: ColorScaleConfig = {
  type: 'INTERPOLATE',
  cutoffs: [
    {
      value: 17,
      color: '#0BA5EC'
    },
    {
      value: 19,
      color: '#36CFC9'
    },
    {
      value: 21,
      color: '#73D13D'
    },
    {
      value: 24,
      color: '#FFA940'
    },
    {
      value: 28,
      color: '#FF4D4F'
    }
  ]
}

export const humidityColorScale: ColorScaleConfig = {
  type: 'INTERPOLATE',
  cutoffs: [
    {
      value: 0,
      color: '#FF4D4F'
    },
    {
      value: 30,
      color: '#FFA940'
    },
    {
      value: 45,
      color: '#FFA940'
    },
    {
      value: 60,
      color: '#73D13D'
    },
    {
      value: 75,
      color: '#36CFC9'
    },
    {
      value: 80,
      color: '#0BA5EC'
    },
    {
      value: 100,
      color: '#0155AC'
    }
  ]
}

export const co2ColorScale: ColorScaleConfig = {
  type: 'INTERPOLATE',
  cutoffs: [
    {
      value: 100,
      color: '#73D13D'
    },
    {
      value: 750,
      color: '#73D13D'
    },
    {
      value: 775,
      color: '#FFA940'
    },
    {
      value: 800,
      color: '#FF4D4F'
    },
    {
      value: 1000,
      color: '#FF4D4F'
    }
  ]
}
